import { useEffect, useState } from 'react'

/**
 * Returns the latest `value` after it has been stable for `delayMs`. Useful as
 * input to a React-Query `queryKey` so distinct stable inputs trigger their
 * own refetch, while rapid changes coalesce into one query.
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
	const [debounced, setDebounced] = useState(value)

	useEffect(() => {
		const id = setTimeout(() => setDebounced(value), delayMs)
		return () => clearTimeout(id)
	}, [value, delayMs])

	return debounced
}
